import { createContext, useContext, useState } from 'react';

const GlobalErrorContext = createContext({
  globalError: null,
  showGlobalError: _error => {},
  clearGlobalError: () => {},
});

export function GlobalErrorProvider({ children }) {
  const [globalError, setGlobalError] = useState(null);

  const showGlobalError = error => setGlobalError(error);
  const clearGlobalError = () => setGlobalError(null);

  return (
    <GlobalErrorContext.Provider value={{ globalError, showGlobalError, clearGlobalError }}>
      {children}
    </GlobalErrorContext.Provider>
  );
}

export const useGlobalError = () => useContext(GlobalErrorContext);
